/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityRegion } from './FacilityRegion';
import {
    FacilityRegionFromJSON,
    FacilityRegionFromJSONTyped,
    FacilityRegionToJSON,
    FacilityRegionToJSONTyped,
} from './FacilityRegion';

/**
 * 
 * @export
 * @interface FindAllFacilityRegions200Response
 */
export interface FindAllFacilityRegions200Response {
    /**
     * 
     */
    data?: Array<FacilityRegion>;
}

/**
 * Check if a given object implements the FindAllFacilityRegions200Response interface.
 */
export function instanceOfFindAllFacilityRegions200Response(value: object): value is FindAllFacilityRegions200Response {
    return true;
}

export function FindAllFacilityRegions200ResponseFromJSON(json: any): FindAllFacilityRegions200Response {
    return FindAllFacilityRegions200ResponseFromJSONTyped(json, false);
}

export function FindAllFacilityRegions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityRegions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FacilityRegionFromJSON)),
    };
}

export function FindAllFacilityRegions200ResponseToJSON(json: any): FindAllFacilityRegions200Response {
    return FindAllFacilityRegions200ResponseToJSONTyped(json, false);
}

export function FindAllFacilityRegions200ResponseToJSONTyped(value?: FindAllFacilityRegions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FacilityRegionToJSON)),
    };
}

